export default "__VITE_ASSET__95309506__"